import { Theme } from "@mui/material";

export const typography = {
  fontFamily: ["Figtree", "Lato"].join(","),
  h1: {
    color: "#002154",
    fontSize: "2.25rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "110%",
  },
  h2: {
    fontSize: "1.75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.925rem",
  },
  h3: {
    fontSize: "1.5rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.65rem",
  },
  h4: {
    fontSize: "1.25rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.375rem",
  },
  h5: {
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.1rem",
  },
  h6: {
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: ".9625rem",
  },
  subtitle1: {
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: ".825rem",
  },
  subtitle2: {
    fontSize: ".625rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: ".6875rem",
  },
  body1: {
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.155rem",
  },
  body2: {
    fontSize: ".8125rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.0725rem",
  },
  caption: {
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: ".99rem",
  },
  overline: {
    fontSize: ".6875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: ".9625rem",
  },
  button: {
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1.5rem",
    textTransform: "none",
  },
  // CUSTOM FONTS
  pill: {
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.5rem",
  },
  cardTitle: {
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1.5rem",
    color: "#334C71",
  },
  cardSubtitle: {
    fontFamily: "Lato",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.125rem",
  },
  cardBodyRegular: {
    fontFamily: "Lato",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.125rem",
  },
  cardBodyHeader: {
    fontFamily: "Figtree",
    fontSize: "1.25rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.5rem",
  },

  cardSectionTitle: {
    color: "#202D63",
    fontFamily: "Figtree",
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "1.5rem",
  },

  // NAVBAR

  navBarGroupTitle: {
    color: "#3D6489",
    overflow: "hidden",
    fontFamily: "Figtree",
    fontSize: ".625rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1rem",
    textTransform: "uppercase",
    textOverflow: "ellipsis",
  },
  navBarItem: {
    color: "#4C6283",
    overflow: "hidden",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1rem",
    textOverflow: "ellipsis",
  },
  navBarItemSelected: {
    color: "#002154",
    overflow: "hidden",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1rem",
    textOverflow: "ellipsis",
  },
  // ACTIVITY
  activityTitle: {
    color: "#002154",
    fontFamily: "Figtree",
    fontSize: "1.75rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.625rem",
  },
  activitySubtitle: {
    color: "#1E4E77",
    fontFamily: "Lato",
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.625rem",
  },

  // multiTab
  multiTab: {
    color: "#1E4E77",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1.5rem",
  },
  multiTabSelected: {
    color: "#002154",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1.5rem",
  },

  // table
  tableHeader: {
    color: "#1E4E77",
    fontFamily: "Figtree",
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.5rem",
  },
  tableCellBold: {
    color: "#172E6B",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "1rem",
  },
  tableCellRegular: {
    color: "#51565A",
    fontFamily: "Lato",
    fontSize: ".8125rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.125rem",
  },

  // Chat Message
  chatMessageBody: {
    color: "#1E4E77",
    fontFamily: "Lato",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1.25rem",
  },
  chatTimeStamp: {
    color: "#73787B",
    fontFamily: "Lato",
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1rem",
  },
  chatSender: {
    color: "#002154",
    fontFamily: "Lato",
    fontSize: ".75rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1rem",
  },

  // form
  formInput: {
    color: "#002154",
    fontFamily: "Lato",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "2.5rem",
  },
  formPlaceholder: {
    color: "#92A6BC",
    fontFamily: "Lato",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "2.5rem",
  },
  formLabel: {
    color: "#1E4E77",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "1.5rem",
  },

  // MODAL
  modalTitle: {
    color: "#002154",
    fontFamily: "Figtree",
    fontSize: "1.25rem",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "1.5rem",
  },
  modalSubtitle: {
    color: "#51565A",
    fontFamily: "Figtree",
    fontSize: ".875rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "1rem",
  },
  fontSize: 22,
  fontWeightBold: 900,
  fontWeightRegular: 600,
  fontWeightMedium: 400,
  fontWeightLight: 200,
} as Theme["typography"];
